import { Component } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.css';

class Faq extends Component{

state = {footerFixed: true}

render(){
    return(
        <div>
            <Navbar/>
            <div class="container" style={{textAlign: "center", marginTop: "20px"}}>
                <h1>How does it work?</h1>
                <p>FeatFinder uses Spotify data to retirieve information about each artist discography to then find songs that have been made together.</p>
                <h1>Do i need Spotify Premium?</h1>
                <p>No, in order to get a list of songs that two artists appear together on you not only don't need to have a Spotify premium but you won't need to login into your Spotify account!</p>
                <h1>A collaboration i know exists doesn't appear, why?</h1>
                <p>Unfortunately, artist don't always credit the others on the songs, for example on Travis Scott's "ASTROWORLD". In this case the application has no current way to detect such songs, future plan is to insert manually each song after a report is made. This also can happen if 2 artists appear together as featured on an album which is old or remote such as a movie soundtrack, this should be rare though.</p>
                <h1>What is discovery mode?</h1>
                <p>It is a different way to find collaborations, instead of 2 artist only one is required. All collaborators with that artist will be displayed, then it'll be possibile to search for the other way around.</p>
                <h1>How can i report an hidden feature?</h1>
                <p>If you know a song that has a feature that is not shown on Spotify such as "SICKO MODE", just email: <a href="mailto:featfinderapp@gmail.com">featfinderapp@gmail.com</a> providing the song title and a list of featured artists, specifying the main one</p>
                <h1>Other questions?</h1>
                <p>Feel free to E-Mail: <a href="mailto:featfinderapp@gmail.com">featfinderapp@gmail.com</a></p>
            </div>
            <Footer fixed={this.state.footerFixed}/>
        </div>
    )
}




}

export default Faq